import fetch from "auth/FetchInterceptor";

const ApprovedOrders = {};

ApprovedOrders.get = function (payload) {
  return fetch({
    url: "/reports/orders-approved?" +
    "startdate=" +
    payload.startDate +
    "&enddate=" +
    payload.endDate +
    "&agency=" +
    payload.agency +
    "&department=" +
    payload.department,
    method: "get",
  });
};

ApprovedOrders.getObx = function(payload = null){
  return fetch({
    url: "/reports/getOrderObx?visitUuid=" + payload,
    method: "get",
  })
}

ApprovedOrders.update = function (data) {
  return fetch({
    url: "/update-order-status",
    method: "put",
    data,
  });
};


export default ApprovedOrders;
